import React from 'react'
import PropTypes from 'prop-types'
import { useLocation } from 'react-router-dom'
import { ClearButton, SaveButton } from 'irmlib/components/FormControls'
import { FlexByRow, XDivider, YDivider, HalfScreen } from 'irmlib/styles'
// import * as constants from 'irmlib/common/constants'
import { MainRouteSubRoutePage } from '../../AppControl/RoutePage'
// import { errorToast } from '../../../common/functions'
// import { useTranslation } from 'react-i18next'
import LocalTemplateFilters from './LocalTemplateFilters'
import LocalViewTemplateData from './LocalViewTemplateData'

const Buttons = (props) => (
  <>
    <ClearButton arrRefs={props.arrRefs} />
    <XDivider width='10px' />
    <SaveButton arrRefs={props.arrRefs} />
  </>
)

Buttons.propTypes = {
  arrRefs: PropTypes.array,
}

const VerticalDivider = () => <YDivider height='15px' />

const LocalViewTemplate = (props) => {
  const location = useLocation()
  const [val, Setval] = React.useState(
    () => location.state?.filterData ?? false
  )

  // const { t } = useTranslation()

  const getSelectedData = (data) => {
    if (data) {
      Setval(data)
    }
  }
  return (
    <MainRouteSubRoutePage
      mainTitle='routeTitles.smartCatalogLocalTemplateManagement'
      // subTitle='routeTitles.myJobs'
    >
      <FlexByRow>
        <HalfScreen>
          <React.Fragment>
            <FlexByRow>
              <LocalTemplateFilters
                selectedData={getSelectedData}
                filterSnapshot={val}
              />
            </FlexByRow>
          </React.Fragment>
        </HalfScreen>
      </FlexByRow>
      <VerticalDivider />
      {val && <LocalViewTemplateData FilterData={val} />}
    </MainRouteSubRoutePage>
  )
}

export default LocalViewTemplate
